module.exports = __webpack_public_path__ + "static/media/gmair_white.7a152c8f.png";